import { render, staticRenderFns } from "./menu-management.vue?vue&type=template&id=713c4925&scoped=true"
import script from "./menu-management.vue?vue&type=script&lang=js"
export * from "./menu-management.vue?vue&type=script&lang=js"
import style0 from "./menu-management.vue?vue&type=style&index=0&id=713c4925&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713c4925",
  null
  
)

export default component.exports